export default {"src":"/_next/static/media/tutorial-build.f8ec160e.svg","height":75,"width":99,"blurWidth":0,"blurHeight":0};